(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-product"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('product-modal')) {
    customElements.define('product-modal', class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
            element.classList.remove('active');
          }
        )
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
          activeMedia.loadContent();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('ul'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }


      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  }

  customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tg-footer"]) return;
  try {
    
if(!customElements.get('tg-signup'))customElements.define('tg-signup',class extends HTMLElement{
 connectedCallback(){
  this.dialog=this.querySelector('dialog');this.trigger=this.querySelector('[data-signup-open]');this.abort=new AbortController();const opt={signal:this.abort.signal};
  this.trigger.addEventListener('click',()=>this.open(true),opt);this.querySelector('[data-signup-close]').addEventListener('click',()=>this.close(),opt);
  this.dialog.addEventListener('cancel',e=>{e.preventDefault();this.close()},opt);this.dialog.addEventListener('click',e=>{const r=this.dialog.getBoundingClientRect();if(e.target===this.dialog&&(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom))this.close()},opt);
  let dismissed=false;try{dismissed=Number(localStorage.getItem('tg-signup-dismissed-until'))>Date.now()}catch(e){}
  if(!dismissed)this.timer=setTimeout(()=>this.open(false),3000);
 }
 open(manual){clearTimeout(this.timer);if(this.dialog.open)return;this.previous=document.activeElement;this.dialog.removeAttribute('data-closing');this.dialog.showModal();if(manual)this.trigger.setAttribute('aria-expanded','true')}
 close(){try{localStorage.setItem('tg-signup-dismissed-until',String(Date.now()+14*86400000))}catch(e){}this.dialog.setAttribute('data-closing','');clearTimeout(this.closeTimer);this.closeTimer=setTimeout(()=>{this.dialog.close();this.dialog.removeAttribute('data-closing');this.trigger.setAttribute('aria-expanded','false');this.previous?.focus?.({preventScroll:true})},matchMedia('(prefers-reduced-motion:reduce)').matches?0:220)}
 disconnectedCallback(){clearTimeout(this.timer);clearTimeout(this.closeTimer);this.abort?.abort();if(this.dialog?.open)this.dialog.close()}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tg-header"]) return;
  try {
    
document.querySelectorAll('.tg-mobile-menu').forEach(menu=>{menu.addEventListener('keydown',event=>{if(event.key==='Escape'){menu.open=false;menu.querySelector('summary').focus()}})});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tg-home"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('tg-drops'))customElements.define('tg-drops',class extends HTMLElement{
 connectedCallback(){
  this.track=this.querySelector('.tg-drop-track');this.track.querySelectorAll('[data-clone]').forEach(el=>el.remove());this.items=[...this.track.children];this.desktop=matchMedia('(min-width:750px)');this.reduced=matchMedia('(prefers-reduced-motion:reduce)');this.playing=!this.reduced.matches;this.hovered=false;this.focused=false;
  this.items.slice(0,5).forEach(item=>{const clone=item.cloneNode(true);clone.dataset.clone='';clone.setAttribute('aria-hidden','true');clone.setAttribute('tabindex','-1');clone.querySelectorAll('a,button,input,select,textarea,[tabindex]').forEach(el=>el.setAttribute('tabindex','-1'));this.track.append(clone)});
  this.toggle=this.querySelector('[data-toggle]');this.toggle.textContent=this.playing?this.toggle.dataset.pause:this.toggle.dataset.play;
  this.abort=new AbortController();const opt={signal:this.abort.signal};
  this.querySelector('[data-next]').addEventListener('click',()=>this.move(1),opt);this.querySelector('[data-prev]').addEventListener('click',()=>this.move(-1),opt);
  this.toggle.addEventListener('click',()=>{this.playing=!this.playing;this.toggle.textContent=this.playing?this.toggle.dataset.pause:this.toggle.dataset.play},opt);
  this.addEventListener('mouseenter',()=>this.hovered=true,opt);this.addEventListener('mouseleave',()=>this.hovered=false,opt);this.addEventListener('focusin',()=>this.focused=true,opt);this.addEventListener('focusout',e=>this.focused=this.contains(e.relatedTarget),opt);
  this.desktop.addEventListener('change',()=>this.track.scrollLeft=0,opt);this.reduced.addEventListener('change',()=>{this.playing=!this.reduced.matches;this.toggle.textContent=this.playing?this.toggle.dataset.pause:this.toggle.dataset.play},opt);
  this.timer=setInterval(()=>{if(this.desktop.matches&&this.playing&&!this.hovered&&!this.focused&&!document.hidden&&this.getBoundingClientRect().bottom>0&&this.getBoundingClientRect().top<innerHeight)this.move(1)},3500);
  [...this.track.children].forEach(card=>{const holder=card.querySelector('.tg-card-image');if(!holder||holder.querySelector('.tg-rgb-layer'))return;const layer=document.createElement('div');layer.className='tg-rgb-layer';layer.setAttribute('aria-hidden','true');holder.querySelectorAll(':scope > img').forEach(img=>{const copy=img.cloneNode(true);copy.alt='';layer.appendChild(copy)});holder.appendChild(layer)});
  this.updateEdges=()=>{const box=this.track.getBoundingClientRect();[...this.track.children].forEach(card=>{const b=card.getBoundingClientRect(),center=b.left+b.width/2-box.left;card.classList.toggle('tg-edge-left',this.desktop.matches&&center<box.width*.2);card.classList.toggle('tg-edge-right',this.desktop.matches&&center>box.width*.8)})};this.resizeObserver=new ResizeObserver(this.updateEdges);this.resizeObserver.observe(this.track);this.updateEdges();
  this.track.addEventListener('scroll',()=>{this.updateEdges();clearTimeout(this.settle);this.settle=setTimeout(()=>{const total=this.step()*this.items.length;if(this.track.scrollLeft>=total-2)this.track.scrollLeft-=total},180)},opt);
 }
 step(){return this.items[0].getBoundingClientRect().width+18}
 move(dir){if(!this.desktop.matches)return;const step=this.step(),total=step*this.items.length;if(dir<0&&this.track.scrollLeft<1)this.track.scrollLeft=total;this.track.scrollTo({left:Math.round(this.track.scrollLeft/step)*step+dir*step,behavior:this.reduced.matches?'instant':'smooth'})}
 disconnectedCallback(){this.resizeObserver?.disconnect();clearInterval(this.timer);clearTimeout(this.settle);this.abort?.abort()}
});

  } catch(e) { console.error(e); }
})();
})();
